var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"contenedor-listado-desktop"}},[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.listadoObras,"items-per-page":20},scopedSlots:_vm._u([{key:"item.clave",fn:function( ref){
var item = ref.item;
return [_c('router-link',{attrs:{"to":{name: 'obra', params: { idObra: item.id }}}},[_vm._v("\n        "+_vm._s(item.clave)+"\n      ")])]}},{key:"item.tipo",fn:function(ref){
var item = ref.item;
return [_c('v-chip',{attrs:{"color":item.tipo.color}},[_c('span',[_vm._v("\n          "+_vm._s(item.tipo.descripcion)+"\n        ")])])]}},{key:"item.acciones",fn:function(ref){
var item = ref.item;
return [_c('opciones',{attrs:{"obra":item}})]}},{key:"item.createdAt",fn:function(ref){
var item = ref.item;
return [_c('fecha-humano',{attrs:{"fecha":new Date(item.createdAt)}})]}},{key:"item.meta",fn:function(ref){
var item = ref.item;
return [_c('cortar-texto',{attrs:{"texto":item.meta}})]}}],null,true)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }